<template>
  <v-layout
    align-center
    style="flex-grow: 0"
  >
    <span
      v-if="label"
      class="subheader-like-label ml-auto"
      style="min-width: 40px"
    >{{ label }}</span>
    <v-select
      v-model="inputHour"
      style="min-width: 48px; max-width: 48px"
      color="msr"
      class="large-bold-selection"
      solo
      hide-details
      append-icon
      :disabled="disabled"
      data-cy="hour-select"
      :menu-props="{
        contentClass: 'cy-hour-select-menu firefox-fix-menu-content-width',
      }"
      :items="hours"
    />
    <div
      class="mx-1 pb-1"
      :class="{'grey--text': disabled}"
      style="font-size: 24px; font-weight: bold"
    >
      :
    </div>
    <v-select
      v-model="inputMinute"
      style="max-width: 48px"
      color="msr"
      class="large-bold-selection"
      solo
      hide-details
      append-icon
      :disabled="disabled"
      data-cy="minute-select"
      :menu-props="{
        contentClass: 'cy-minute-select-menu firefox-fix-menu-content-width',
      }"
      :items="minutes"
    />
  </v-layout>
</template>

<script>
export default {
  props: {
    /** A string like '12:30' meant to be used as v-model.sync */
    time: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /** Optional minute stepsize e.g. 5 or 15 */
    minuteStepSize: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      hours: this.makeStringRange(24),
      minutes: this.makeStringRange(60, this.minuteStepSize, true),
    };
  },
  computed: {
    inputHour: {
      get() {
        const hour = Number(this.hourStringFromTimeString(this.time));
        return this.addPrefixZero(hour);
      },
      set(hourString) {
        this.updateTimeStringHour(hourString);
      },
    },
    inputMinute: {
      get() {
        const incomingMinute = Number(
          this.minuteStringFromTimeString(this.time)
        );
        // Incoming minute may be e.g. 27, whereas with a stepsize of
        // 5 we may only have 25 and 30 as options: Find closest match.
        const steppedMinute = Number(
          this.findClosestValue(this.minutes, incomingMinute)
        );

        // HACK: This is a getter, but if we must choose a new value
        //   due to our stepsize, we also need to sync that to the
        //   outside world by emitting an update signal.
        const changed = incomingMinute !== steppedMinute;
        if (changed) {
          this.updateTimeStringMinute(steppedMinute);
        }

        return this.addPrefixZero(steppedMinute);
      },
      set(minuteString) {
        this.updateTimeStringMinute(minuteString);
      },
    },
  },
  methods: {
    updateTimeStringMinute(minuteString) {
      const hourString = this.hourStringFromTimeString(this.time);
      const time = `${hourString}:${minuteString}`;
      this.$emit('update:time', time);
    },
    updateTimeStringHour(hourString) {
      const minuteString = this.minuteStringFromTimeString(this.time);
      const time = `${hourString}:${minuteString}`;
      this.$emit('update:time', time);
    },
    hourStringFromTimeString(timeStr) {
      return timeStr.split(':')[0];
    },
    minuteStringFromTimeString(timeStr) {
      return timeStr.split(':')[1];
    },
    findClosestValue(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        const current = arr[i];
        if (current < val) {
          continue;
        }
        const deltaCurrent = Math.abs(val - current);
        const previous = arr[i - 1];
        if (previous === undefined) {
          return current;
        }
        const deltaPrevious = Math.abs(val - previous);
        if (deltaPrevious < deltaCurrent) {
          return previous;
        }
        return current;
      }
      return arr[arr.length - 1];
    },
    addPrefixZero(num) {
      let str = String(num);
      if (str < 10) {
        str = '0' + str;
      }
      return str;
    },
    makeStringRange(n, step = 1) {
      const arr = [];
      for (let i = 0; i < n; i += step) {
        let str = String(i);
        if (true) {
          str = this.addPrefixZero(str);
        }
        arr.push(str);
      }
      return arr;
    },
  },
};
</script>

<style>
.subheader-like-label {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  font-weight: 500;
}

.v-select.large-bold-selection {
  font-size: 20px !important;
  font-weight: bold;
}

.v-menu__content.cy-hour-select-menu .v-list__tile--active,
.v-menu__content.cy-minute-select-menu .v-list__tile--active {
  font-size: 20px;
  font-weight: bold;
}

/* Dropdown with scrollbar is squashed on Firefox when the parent v-select is limited to 48px width. */
.firefox-fix-menu-content-width .v-list__tile__content {
  min-width: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/TimePicker.vue